module.exports = __webpack_public_path__ + "img/welding-5.c41b980d.jpg";